import React, { ChangeEvent } from "react";
import { IMaskInput } from "react-imask";
import { InputBaseComponentProps } from "@material-ui/core/InputBase/InputBase";
import { MaskConfiguration } from "./MaskConfigurations";

interface MaskedInputProps extends InputBaseComponentProps {
  masked?: MaskConfiguration;
  onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const MaskedInput = React.forwardRef<HTMLElement, MaskedInputProps>(function MaskedInput(props, ref) {
  const { onChange, masked, ...other } = props;
  return (
    <IMaskInput
      {...other}
      {...masked}
      {...{
        /**
         * restructured to circumvent issue with react-imask types which leads to IMaskInput not accepting valid props
         * https://github.com/uNmAnNeR/imaskjs/issues/554
         *
         * ImaskInput props are typechecked by passing mask configuration via CustomTextField
         */

        inputRef: ref,
        defaultValue: props.value,
        onAccept: (value: string) => {
          onChange({ target: { name: props.name, value } } as ChangeEvent<HTMLInputElement | HTMLTextAreaElement>);
        },
      }}
    />
  );
});

export default MaskedInput;
